import * as React from "react";
import { connect  } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import {
  createEmptyEnum,
  createEmptyIoBoardType,
  createEmptyIoDatatype,
  createEmptyIoOption,
  createEmptyIoBasicDatatype,
  createEmptyIoDataSection,
  createEmptyIoOptionType
} from "../../../utils/pdApiUtils";
import { EditActions, editActions } from "../../../actions/editActions";
import EnumTable from "../../common/EnumTable/EnumTable";
import ActionMenu from "../../common/ActionMenu/ActionMenu";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import EditIoDatatype from "../../Editing/EditIoDatatype";
import ContentLayout from "../../../components/ContentLayout/ContentLayout";
import NavigationLink from "../../../components/NavigationLink/NavigationLink";
import EditIoBoardType from "../../Editing/EditIoBoardType";
import EditIoBasicDataType from "../../Editing/EditIoBasicDataType";
import EditIoDataSection from "../../Editing/EditIoDataSections";
import EditIoEnumType from "../../Editing/EditIoEnumType";
import { parseUrlToName, parseNameToUrl } from "../../../utils/utils";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";

type StateProps = {
  pdApi: State.PdApi;
  editView: State.EditView;
  toggleChildView: State.ToggleChildView;
  filterOptions: State.FilterOptions;
};

type DispatchProps = {
  /** Connected actions */
  editActions: typeof editActions;
};
type OwnProps = {
  toggleModal: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  match: any;
};
// Props of the component
export type IOEnumerationsProps = StateProps & DispatchProps & OwnProps;

type IOEnumerationsState = {
  activeMenu: State.IOEnumerationsSubmenu;
  isModalOpen: boolean;
  tableColumnFilters: {
    [key in State.IOEnumerationsSubmenu]: Filter[];
  };
};

export class IOEnumerations extends React.Component<IOEnumerationsProps, IOEnumerationsState> {
  subMenus: State.IOEnumerationsSubmenu[] = [
    "IO Board Types",
    "IO CPUs",
    "IO Networks",
    "IO Options",
    "IO Datatypes",
    "IO Basic Data Types"
  ];

  subPages: Internal.IOEnumSubPages = {
    "IO Board Types": {
      itemName: "io board type",
      PdApiField: "ioBoardTypes",
      dataView: EnumTable,
      createEmpty: createEmptyIoBoardType,
      setExtraProperties: null,
      editor: EditIoBoardType
    },
    "IO CPUs": {
      itemName: "io cpu",
      PdApiField: "ioCpuEnums",
      dataView: EnumTable,
      createEmpty: createEmptyEnum,
      setExtraProperties: null
    },
    "IO Networks": {
      itemName: "io network",
      PdApiField: "ioNetworks",
      dataView: EnumTable,
      createEmpty: createEmptyEnum,
      setExtraProperties: null
    },
    "IO Options": {
      itemName: "io option",
      PdApiField: "ioOptions",
      dataView: EnumTable,
      createEmpty: createEmptyIoOption,
      setExtraProperties: null,
      editor: EditIoDatatype
    },
    "IO Datatypes": {
      itemName: "io datatype",
      PdApiField: "ioDataTypes",
      dataView: EnumTable,
      createEmpty: createEmptyIoDatatype,
      setExtraProperties: null,
      editor: EditIoDatatype
    },
    "IO Basic Data Types": {
      itemName: "io basic data type",
      PdApiField: "ioBasicDataTypes",
      dataView: EnumTable,
      createEmpty: createEmptyIoBasicDatatype,
      setExtraProperties: null,
      editor: EditIoBasicDataType
    }
  };

  state = {
    activeMenu: this.props.match.params.activeMenu
      ? (parseUrlToName(this.props.match.params.activeMenu) as State.IOEnumerationsSubmenu)
      : "IO Board Types",
    isModalOpen: false,
    tableColumnFilters: {
      "IO Board Types": [],
      "IO CPUs": [],
      "IO Networks": [],
      "IO Options": [],
      "IO Datatypes": [],
      "IO Basic Data Types": [],
      "IO Data Sections" : [],
      "IO Options Enum Type": []
    }
  };

  componentDidUpdate(): void {
    const parseActiveMenuFromURL = this.props.match.params.activeMenu
      ? (parseUrlToName(this.props.match.params.activeMenu) as State.IOEnumerationsSubmenu)
      : "IO Board Types";
    if (this.state.activeMenu !== parseActiveMenuFromURL) {
      this.setState({ activeMenu: parseActiveMenuFromURL });
    }
  }
  render(): JSX.Element {
    const { activeMenu } = this.state;
    const { isChildOpen } = this.props.toggleChildView;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const links = Object.keys(this.subPages).map((name: any) => (
      <NavigationLink
        key={name}
        to={"/elevator/io-enumerations/" + parseNameToUrl(name)}
        name={name}
      />
    ));
    const dataView = this.getDataView(activeMenu, isChildOpen);
    const actionMenu = this.getActionMenu(activeMenu, isChildOpen);

    return (
      <>
        <ContentLayout submenu={links} actionMenu={actionMenu} dataView={dataView} />
        {this.buildModal(activeMenu, isChildOpen)}
      </>
    );
  }

  
  private setColumnFilters = (
    subMenuRoute: State.IOEnumerationsSubmenu,
    newFilters: Filter[] // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): any => { 
    const newFilterSet = { ...this.state.tableColumnFilters, [subMenuRoute]: newFilters };
    this.setState(prevState => ({
      ...prevState,
      tableColumnFilters: newFilterSet
    }));
  };

  private getDataView = (subPage: string, isOpen: boolean) => {
    if (subPage === "IO Basic Data Types" && isOpen) {
      return (
        <EnumTable
          subMenuRoute={"IO Data Sections"}
          toggleModal={this.toggleModal}
          dataFieldName={"iodataSections"}
          editor={EditIoDataSection}
          setColumnFilters={this.setColumnFilters}
        />
      );
    } else if (subPage === "IO Options" && isOpen) {
      return (
        <EnumTable
          subMenuRoute={"IO Options Enum Type"}
          toggleModal={this.toggleModal}
          dataFieldName={"ioOptionsEnumType"}
          editor={EditIoEnumType}
          setColumnFilters={this.setColumnFilters}
        />
      );
    } else {
      return (
        <EnumTable
          subMenuRoute={this.state.activeMenu}
          toggleModal={this.toggleModal}
          dataFieldName={this.subPages[this.state.activeMenu].PdApiField}
          editor={this.subPages[this.state.activeMenu].editor}
          setColumnFilters={this.setColumnFilters}
        />
      );
    }
  };

  private getActionMenu = (subPage: State.IOEnumerationsSubmenu, isOpen: boolean) => {
    if (subPage === "IO Basic Data Types" && isOpen) {
      return (
        <ActionMenu
          {...this.props}
          subMenuRoute={"IO Data Sections"}
          itemName={"IO Data Sections"}
          selectedColumnsName={"IO Data Sections"}
          dataFieldName={"iodataSections"}
          setExtraProperties={null}
          createEmpty={createEmptyIoDataSection}
          groupName="Lift"
          columnFilters={this.state.tableColumnFilters["IO Data Sections"]}
        />
      );
    } else if (subPage === "IO Options" && isOpen) {
      return (
        <ActionMenu
          {...this.props}
          subMenuRoute={"IO Options Enum Type"}
          itemName={"IO Options Enum Type"}
          selectedColumnsName={"IO Options Enum Type"}
          dataFieldName={"ioOptionsEnumType"}
          setExtraProperties={null}
          createEmpty={createEmptyIoOptionType}
          groupName="Lift"
          columnFilters={this.state.tableColumnFilters["IO Options Enum Type"]}
        />
      );
    } else {
      return (
        <ActionMenu
          {...this.props}
          subMenuRoute={this.state.activeMenu}
          itemName={this.subPages[this.state.activeMenu].itemName}
          selectedColumnsName={this.state.activeMenu}
          dataFieldName={this.subPages[this.state.activeMenu].PdApiField}
          setExtraProperties={null}
          createEmpty={this.subPages[this.state.activeMenu].createEmpty}
          groupName="Lift"
          columnFilters={this.state.tableColumnFilters[subPage]}
        />
      );
    }
  };
  private toggleModal = (): void => {
    this.setState(prevState => ({
      ...prevState,
      isModalOpen: !prevState.isModalOpen
    }));
  };

  private buildModal = (subPage: string, isOpen: boolean) => {
    if (subPage === "IO Basic Data Types" && isOpen) {
      const content = <span>Are you sure you want to delete this IO DATA SECTIONS item?</span>;
      return (
        <ConfirmationModal
          isOpen={this.state.isModalOpen}
          size="mini"
          header="Confirm delete"
          content={content}
          confirmText="Confirm"
          cancelText="Cancel"
          onConfirm={() => this.props.editActions.delete("iodataSections" as Api.OptionsGrud)}
          onCancel={this.toggleModal}
        />
      );
    } else if (subPage === "IO Options" && isOpen) {
      const content = <span>Are you sure you want to delete this IO Options EnumType item?</span>;
      return (
        <ConfirmationModal
          isOpen={this.state.isModalOpen}
          size="mini"
          header="Confirm delete"
          content={content}
          confirmText="Confirm"
          cancelText="Cancel"
          onConfirm={() => this.props.editActions.delete("ioOptionsEnumType" as Api.OptionsGrud)}
          onCancel={this.toggleModal}
        />
      );
    } else {
      const content = (
        <span>
          Are you sure you want to delete this {this.subPages[this.state.activeMenu].itemName}?
        </span>
      );
      return (
        <ConfirmationModal
          isOpen={this.state.isModalOpen}
          size="mini"
          header="Confirm delete"
          content={content}
          confirmText="Confirm"
          cancelText="Cancel"
          onConfirm={() =>
            this.props.editActions.delete(
              this.subPages[this.state.activeMenu].PdApiField as Api.OptionsGrud
            )
          }
          onCancel={this.toggleModal}
        />
      );
    }
  };
}

const mapStateToProps = (state: State.Root) => ({
  pdApi: state.pdApi,
  editView: state.editView,
  toggleChildView: state.toggleChildView,
  filterOptions: state.filterOptions
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(IOEnumerations);
